import Flyout from "../_private/Flyout/index.js";
import * as React from "react";
import getPaddingStyles from "../../styles/padding/index.js";
import { classNames } from "../../utilities/helpers.js";
import s from "./Popover.module.css";
const Popover = (props) => {
    const { id, forcePosition, onOpen, onClose, active, defaultActive, children, width, contentGap, variant = "elevated", triggerType = "click", position = "bottom", disableHideAnimation, instanceRef, borderless = false, } = props;
    const padding = props.padding ?? (variant === "headless" ? 0 : 4);
    const trapFocusMode = props.trapFocusMode || (triggerType === "hover" ? "content-menu" : undefined);
    const paddingStyles = getPaddingStyles(padding);
    const contentClassName = classNames(s.content, !!width && s["content--has-width"], variant && s[`content--variant-${variant}`], borderless && s["content--borderless"], paddingStyles?.classNames);
    return (
    // @ts-ignore
    React.createElement(Flyout, { id: id, instanceRef: instanceRef, position: position, forcePosition: forcePosition, onOpen: onOpen, onClose: onClose, trapFocusMode: trapFocusMode, triggerType: triggerType, active: active, defaultActive: defaultActive, width: width, disableHideAnimation: disableHideAnimation, contentGap: contentGap, contentClassName: contentClassName, contentAttributes: { style: { ...paddingStyles?.variables } } }, children));
};
Popover.Trigger = Flyout.Trigger;
Popover.Content = Flyout.Content;
export default Popover;
